import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    this.showPanel(this.activePanelId());
  }

  select(event) {
    event.preventDefault();
    const panelId = event.currentTarget.getAttribute("data-faq-tab");
    if (panelId) this.showPanel(panelId);
  }

  activePanelId() {
    const activeTab = this.tabTargets.find((tab) =>
      tab.classList.contains("is-active")
    );
    return (
      activeTab?.getAttribute("data-faq-tab") ||
      this.tabTargets[0]?.getAttribute("data-faq-tab")
    );
  }

  showPanel(panelId) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.getAttribute("data-faq-tab") === panelId;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    this.panelTargets.forEach((panel) => {
      const isActive = panel.getAttribute("data-faq-panel") === panelId;
      panel.hidden = !isActive;
      panel.classList.toggle("is-active", isActive);
    });
  }
}
